{
  "root": {
    "error": {
      "title": "Impossible de charger cette page"
    },
    "backToCanvases": "Retour à mes canvas",
    "notFound": {
      "title": "Page introuvable",
      "message": "Cette adresse ne correspond à rien dans l'application."
    }
  },
  "app": {
    "openMenu": "Ouvrir le menu",
    "menu": "Menu"
  },
  "inbox": {
    "title": "Boîte de réception",
    "subtitle": "Tout ce que Nolë a fait et que vous n'avez pas encore regardé, sur tous vos canvas."
  },
  "tutorials": {
    "title": "Tutoriels",
    "subtitle": "De courts guides pour tirer le meilleur de vos canvas et de Nolë.",
    "comingSoon": "Bientôt disponible",
    "featured": {
      "badge": "Commencez ici",
      "title": "Nolënor en deux minutes",
      "description": "Créez un canvas, déposez-y quelques documents et demandez à Nolë de les parcourir avec vous."
    },
    "items": {
      "firstCanvas": {
        "title": "Votre premier canvas",
        "description": "Ajoutez des documents, des notes et des liens, puis organisez-les à votre façon."
      },
      "withNole": {
        "title": "Travailler avec Nolë",
        "description": "Joignez des blocs, donnez des instructions, relisez ce qu'elle a modifié."
      },
      "tablesApps": {
        "title": "Tableaux et apps",
        "description": "Des données structurées et de petits outils qui vivent sur le canvas."
      },
      "connectAssistants": {
        "title": "Connecter Claude ou ChatGPT",
        "description": "Utilisez vos canvas depuis d'autres assistants grâce à MCP."
      },
      "capture": {
        "title": "Capturer en déplacement",
        "description": "Notes vocales, photos et liens depuis votre téléphone."
      },
      "shortcuts": {
        "title": "Raccourcis clavier",
        "description": "Déplacez-vous et créez des blocs sans la souris."
      }
    }
  },
  "canvasRoute": {
    "loadError": "Impossible de charger ce canvas"
  },
  "signin": {
    "toasts": {
      "googleFailed": "Impossible de lancer la connexion avec Google. Veuillez réessayer.",
      "verificationSent": "Nous vous avons envoyé un code de vérification par email.",
      "loggedIn": "Vous êtes connecté !",
      "accountCreated": "Votre compte a été créé !",
      "emailVerified": "Email vérifié !",
      "resetSent": "Nous vous avons envoyé un code de réinitialisation par email.",
      "passwordUpdated": "Mot de passe mis à jour !"
    },
    "errors": {
      "accountExists": "Ce compte existe déjà. Connectez-vous ou utilisez une autre adresse email.",
      "passwordTooShort": "Le mot de passe doit contenir au moins 8 caractères.",
      "incorrectPassword": "Mot de passe incorrect.",
      "noAccount": "Aucun compte n'est associé à cette adresse email.",
      "invalidEmail": "Adresse email invalide.",
      "loginFailed": "Connexion impossible. Veuillez réessayer.",
      "invalidCode": "Code invalide ou expiré.",
      "noPasswordAccount": "Aucune connexion par mot de passe pour cette adresse. Si vous vous êtes inscrit avec Google, utilisez « Continuer avec Google ».",
      "resetFailed": "Impossible d'envoyer le code de réinitialisation. Veuillez réessayer."
    },
    "headings": {
      "newPassword": "Choisissez un nouveau mot de passe",
      "checkEmail": "Consultez vos emails",
      "resetPassword": "Réinitialiser votre mot de passe",
      "welcomeBack": "Bon retour parmi nous",
      "createAccount": "Créer un compte"
    },
    "subtitles": {
      "codeSent": "Nous avons envoyé un code à <email>{{email}}</email>",
      "forgot": "Nous vous enverrons par email un code pour choisir un nouveau mot de passe",
      "signIn": "Connectez-vous à votre compte pour continuer",
      "signUp": "Commencez gratuitement"
    },
    "fields": {
      "newPassword": "Nouveau mot de passe",
      "password": "Mot de passe",
      "emailPlaceholder": "nom@exemple.com"
    },
    "actions": {
      "updatePassword": "Mettre à jour le mot de passe",
      "sendCode": "Envoyer le code",
      "google": "Continuer avec Google",
      "forgotPassword": "Mot de passe oublié ?",
      "logIn": "Se connecter",
      "createAccount": "Créer un compte",
      "backToLogIn": "Retour à la connexion"
    },
    "or": "ou",
    "switch": {
      "noAccount": "Pas encore de compte ?",
      "hasAccount": "Vous avez déjà un compte ?"
    }
  },
  "newCanvas": "Nouveau canvas",
  "sidebar": {
    "mainNav": "Principal",
    "nav": {
      "home": "Accueil",
      "inbox": "Boîte de réception",
      "tutorials": "Tutoriels"
    },
    "aiUsage": {
      "title": "Usage de l'IA",
      "period": "30 derniers jours"
    },
    "account": {
      "fallbackName": "Votre compte",
      "signOut": "Se déconnecter"
    }
  },
  "home": {
    "welcome": {
      "title": "Bienvenue sur Nolënor",
      "description": "Un canvas est un tableau infini. Déposez-y des documents, des images, de l'audio, des liens et des notes, reliez-les entre eux, et demandez à Nolë — l'assistante qui lit tout ce qui se trouve sur le canvas — de les travailler avec vous.",
      "cta": "Créer votre premier canvas"
    },
    "greeting": {
      "morning": "Bonjour",
      "afternoon": "Bon après-midi",
      "evening": "Bonsoir",
      "morningWithName": "Bonjour, {{name}}",
      "afternoonWithName": "Bon après-midi, {{name}}",
      "eveningWithName": "Bonsoir, {{name}}"
    },
    "subtitle": {
      "tasks_one": "{{count}} tâche demande votre attention.",
      "tasks_other": "{{count}} tâches demandent votre attention.",
      "firstCanvas": "Créons votre premier canvas.",
      "caughtUp": "Vous êtes à jour."
    },
    "workspace": {
      "openCanvas": "Ouvrir {{name}}",
      "shared": "Partagé",
      "yours": "À vous",
      "actionsFor": "Actions pour {{name}}",
      "tasks_one": "{{count}} tâche",
      "tasks_other": "{{count}} tâches"
    },
    "task": {
      "working": "Nolë s'en occupe…",
      "inThread": "Dans « {{title}} »",
      "timeSpent": "Temps passé",
      "blocksTouched": "Blocs modifiés",
      "stillRunning": "Toujours en cours",
      "waiting": "En attente de votre réponse",
      "markReviewed": "Marquer comme vu",
      "stillRunningAria": "{{title}} est toujours en cours",
      "waitingAria": "{{title}} attend votre réponse",
      "markReviewedAria": "Marquer {{title}} comme vu"
    },
    "tasks": {
      "title": "Demande votre attention",
      "clearAll": "Effacer toutes les tâches terminées",
      "empty": {
        "title": "Vous êtes à jour",
        "description": "Quand Nolë termine quelque chose, cela s'affiche ici jusqu'à ce que vous l'ayez consulté."
      },
      "undoAria": "Annuler l'effacement de {{title}}",
      "viewAll_one": "Voir {{count}} tâche dans la boîte de réception",
      "viewAll_other": "Voir les {{count}} tâches dans la boîte de réception"
    },
    "recent": {
      "title": "Canvas récents",
      "filterLabel": "Filtrer les canvas",
      "filters": {
        "all": "Tous",
        "mine": "Les miens",
        "shared": "Partagés avec moi"
      },
      "layoutLabel": "Disposition",
      "gridView": "Vue en grille",
      "listView": "Vue en liste"
    }
  },
  "loading": {
    "then": "puis",
    "gestures": {
      "click": "Clic",
      "rightClick": "Clic droit",
      "doubleClick": "Double-clic",
      "drag": "Glisser"
    },
    "tips": {
      "altClickBlock": "[Alt] + {click} sur un bloc → le joindre à Nolë",
      "altClickCanvas": "[Alt] + {click} sur le canvas vide → y diriger Nolë",
      "shiftDrag": "[Shift] + {drag} → guides d'alignement",
      "modDrag": "[Mod] + {drag} sur un bloc → les blocs liés suivent",
      "appearance": "{right-click} → Apparence → changer de variante",
      "compactFrame": "{right-click} sur une frame → Compacte → plus de place",
      "mention": "{click} sur une mention → y aller · [Mod] + {click} → ouvrir",
      "scaleTitle": "{right-click} sur un titre → Suivre le zoom",
      "lasso": "[Mod] + lasso → ignorer les frames",
      "alignSelection": "{right-click} sur une sélection → aligner · ranger",
      "dragConnection": "{drag} une connexion vers le canvas vide → nouveau bloc",
      "dropBlock": "[T] [D] [I] [A] [L] → poser un bloc sous le pointeur",
      "search": "[Mod] [K] → tout rechercher, même dans les PDF",
      "jump": "[Mod] [P] → aller à un canvas ou un favori",
      "bookmark": "{right-click} sur le canvas → Ajouter un favori ici · [B] → liste",
      "frame": "[F] → dessiner une frame",
      "pan": "[Space] + {drag} → se déplacer",
      "editLabel": "{double-click} sur une connexion → modifier son libellé",
      "snapWindow": "{drag} une fenêtre vers un bord de l'écran → l'ancrer",
      "dictate": "Maintenez [Ctrl] [Alt] dans le chat → dicter"
    }
  },
  "appError": {
    "message": "L'application a rencontré une erreur inattendue. Recharger la page suffit généralement — votre travail est enregistré sur le serveur."
  },
  "errorDisplay": {
    "fallbackTitle": "Erreur",
    "fallbackMessage": "Une erreur est survenue"
  },
  "update": {
    "title": "✨ Nolënor vient d'être mis à jour",
    "messageAuto": "Une nouvelle version est sortie pendant que vous travailliez. Elle est en cours de téléchargement et la page se rafraîchira d'elle-même dans quelques secondes — votre travail est enregistré.",
    "messageManual": "Une nouvelle version est sortie pendant que vous travailliez. Rechargez la page pour l'utiliser — votre travail est enregistré.",
    "downloading": "Téléchargement de la nouvelle version…",
    "refreshing": "Actualisation…",
    "reloadToUpdate": "Recharger pour mettre à jour",
    "checking": "Recherche de mises à jour…",
    "reloadPage": "Recharger la page",
    "toast": "✨ Une nouvelle version de Nolënor est disponible."
  },
  "colors": {
    "red": "Rouge",
    "orange": "Orange",
    "yellow": "Jaune",
    "lime": "Citron vert",
    "green": "Vert",
    "teal": "Bleu canard",
    "sky": "Ciel",
    "blue": "Bleu",
    "purple": "Violet",
    "pink": "Rose",
    "grey": "Gris",
    "white": "Blanc",
    "default": "Par défaut",
    "transparent": "Transparent"
  },
  "layout": {
    "redo": "Rétablir",
    "layers": "Calques",
    "dialog": {
      "description": "Organisez les lignes, les colonnes et leur contenu. Rien ne change tant que vous n'appliquez pas.",
      "unsaved": "Modifications non appliquées. Le board se met à jour quand vous appliquez.",
      "pristine": "Rien ne change tant que vous n'appliquez pas."
    },
    "discard": {
      "title": "Abandonner les modifications de la mise en page ?",
      "description": "Si vous fermez maintenant, les modifications non appliquées seront perdues.",
      "keepEditing": "Continuer l'édition",
      "confirm": "Abandonner les modifications"
    },
    "align": {
      "top": "Haut",
      "left": "Gauche",
      "middle": "Milieu",
      "center": "Centre",
      "bottom": "Bas",
      "right": "Droite",
      "fill": "Remplir",
      "spread": "Répartir"
    },
    "row": "Ligne",
    "column": "Colonne",
    "rowRoot": "Ligne (racine)",
    "columnRoot": "Colonne (racine)",
    "between": "Entre {{min}} et {{max}}",
    "elements_one": "{{count}} élément",
    "elements_other": "{{count}} éléments",
    "direction": "Direction",
    "alignItems": "Aligner les éléments",
    "distribute": "Répartition",
    "gap": "Espacement (px)",
    "padding": "Marge intérieure (px)",
    "addInside": "Ajouter à l'intérieur",
    "addAfter": "Ajouter après",
    "wrapRow": "Entourer d'une ligne",
    "wrapColumn": "Entourer d'une colonne",
    "refusal": {
      "tooManyChildren": "Une ligne ou une colonne contient au plus {{max}} éléments. Regroupez-en d'abord certains dans une ligne ou une colonne.",
      "tooDeep": "Les lignes et les colonnes s'imbriquent sur {{max}} niveaux au plus. Sélectionnez d'abord un emplacement moins profond."
    }
  }
}
